// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getWeekYear as fn } from "../getWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getWeekYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getWeekYearWithOptions;
